import type { ApiClient } from './client';

export type OAuthClient = {
  client_id: string;
  name: string;
  app_type?: string;
  client_metadata?: { user_sub?: string };
};

export type CreateClientResult = {
  client_id: string;
  client_secret: string;
  name: string;
};

export type RotateClientResult = {
  client_id: string;
  client_secret: string;
};

export type DeleteClientResult = {
  client_id: string;
  deleted: boolean;
};

export function createClientsApi(client: ApiClient, baseUrl: string) {
  return {
    list(): Promise<{ clients: OAuthClient[] }> {
      return client.request<{ clients: OAuthClient[] }>(baseUrl, { method: 'GET' });
    },
    create(name: string): Promise<CreateClientResult> {
      return client.request<CreateClientResult>(baseUrl, {
        method: 'POST',
        body: { name },
      });
    },
    rotate(clientId: string): Promise<RotateClientResult> {
      return client.request<RotateClientResult>(`${baseUrl}${clientId}/rotate`, { method: 'POST' });
    },
    remove(clientId: string): Promise<DeleteClientResult> {
      return client.request<DeleteClientResult>(`${baseUrl}${clientId}`, { method: 'DELETE' });
    },
  };
}